import React, { useEffect } from "react";
import "./Navstyle.css";
import { useNavigate } from "react-router-dom";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
function Navbar() {
  var noTransition = {
    transition: "none"
  };
  useEffect(() => {
    document.querySelectorAll(".opts").forEach(e => {
      e.addEventListener("mouseenter", E => {
        E.target.classList.add("highlight");
      });
      e.addEventListener("mouseleave", E => {
        E.target.classList.remove("highlight");
      });
    });
  }, []);

  var navigate = useNavigate();
  return (
    <nav>
      <div className="top-nav">
        <div className="left">
          <img src="NFRAC-png.png" />
          <div>
            <b
              style={{
                fontSize: window.screen.width > 750 ? "1.2rem" : "0.9rems"
              }}
            >
              उन्नत कंप्यूटिंग में अनुसंधान के लिए राष्ट्रीय संघ
            </b>
            <p className="heading">
              National Federation for Research in Advanced Computing (NFRAC)
            </p>
            <p>Department of Computer Science Engineering</p>
          </div>
        </div>
        <div className="right">
          <div>
            <img
              onClick={() => {
                window.open("https://www.facebook.com/NFRAC/");
              }}
              src="social-media/facebook-logo.png"
            />
            <img
              onClick={() => {
                window.open("https://www.instagram.com/nfrac.in/");
              }}
              src="social-media/instagram.png"
            />
            <img
              onClick={() => {
                window.open("https://twitter.com/nfrac_in");
              }}
              src="social-media/twitter.png"
            />
            <img
              onClick={() => {
                window.open(
                  "https://www.youtube.com/channel/UCl1ta3StOr8hmyuMv_7wydA"
                );
              }}
              src="social-media/youtube.png"
            />
          </div>
          <div>
            <input
              onKeyUp={e => {
                if (e.keyCode == 13 && e.target.value.length != 0) {
                  localStorage.setItem(
                    "user-searched-for",
                    e.target.value.trim()
                  );
                  var Tokens = e.target.value
                    .trim()
                    .toLowerCase()
                    .split(/[\s]+/g);
                  var list = [];
                  var link =
                    "https://rohitpidishetty.github.io/NFRAC_Projects/Projects.json";
                  fetch(link)
                    .then(res => res.json())
                    .then(project_list => {
                      var years = Object.keys(project_list);
                      years.forEach(yr => {
                        var projects = Object.values(project_list[yr]);
                        projects.forEach(project => {
                          var score = 0;
                          var title = project.title;
                          Tokens.forEach(parent_token => {
                            project.domain.forEach(token => {
                              if (parent_token === token) score++;
                            });
                          });
                          if (score !== 0)
                            list.push({ title: title, score: score });
                        });
                      });
                      for (var i = 0; i < list.length; i++) {
                        for (var j = 0; j < list.length - i - 1; j++) {
                          if (list[j].score < list[j + 1].score) {
                            var temp = list[j];
                            list[j] = list[j + 1];
                            list[j + 1] = temp;
                          }
                        }
                      }
                      var finalFilter = [];
                      var FilterPhase1 = [];
                      years.forEach(yr => {
                        FilterPhase1.push(...Object.values(project_list[yr]));
                      });
                      list.forEach(node => {
                        FilterPhase1.forEach(child => {
                          if (node.title === child.title)
                            finalFilter.push(child);
                        });
                      });
                      localStorage.setItem(
                        "search-projects-for",
                        JSON.stringify(finalFilter)
                      );
                    })
                    .then(e => {
                      window.open("search-results", "_self");
                    })
                    .catch(e => {
                      navigate("/error");
                    });
                }
              }}
              placeholder="Search NFRAC projects"
            />
          </div>
        </div>
      </div>
      <div className="bottom-nav">
        {window.screen.width < 750
          ? <img
            className="toggler"
            src="main-menu.png"
            style={{ width: "8%" }}
            onClick={() => {
              for (var i = 0; i < 10; i++)
                document
                  .querySelectorAll(".opts")
                [i].classList.toggle("hide");
              document
                .querySelector(".bottom-nav")
                .classList.toggle("minimize");
            }}
          />
          : <p />}
        {window.screen.width > 750
          ? <p
            onClick={() => {
              navigate("/index");
            }}
            className="opts"
          >
            Home
          </p>
          : <p
            onClick={() => {
              navigate("/index");
            }}
            className="opts hide"
          >
            Home
          </p>}

        {window.screen.width > 750
          ? <p
            onMouseEnter={() => {
              document
                .querySelector(".abt_itms")
                .classList.toggle("about_items_show");
              var arrow = document.querySelector("#arrow_direction");
              arrow.innerHTML =
                arrow.innerHTML == "keyboard_arrow_up"
                  ? "keyboard_arrow_down"
                  : "keyboard_arrow_up";
            }}
            onClick={() => {
              navigate("/about");
            }}
            className="opts abt"
            id="about"
          >
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              About{" "}
              <span id="arrow_direction" class="material-symbols-outlined">
                keyboard_arrow_down
              </span>
            </span>
            <div className="abt_itms about_items">
              <p
                onClick={() => {
                  navigate("/about");
                }}
              >
                Profile
              </p>
              <p
                onClick={() => {
                  window.open("/whoswho", "_self");
                }}
              >
                Who's who
              </p>
              <p
                onClick={() => {
                  window.open("/latest_notifications", "_self");
                }}
              >
                Latest updates
              </p>
            </div>
          </p>
          : <p
            onClick={() => {
              navigate("/about");
            }}
            className="opts hide"
          >
            About
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={() => {
              navigate("/nfrac_projects");
            }}
            className="opts"
            id="nfrac_projects"
          >
            Projects
          </p>
          : <p
            onClick={() => {
              navigate("/nfrac_projects");
            }}
            className="opts hide"
          >
            Projects
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={() => {
              navigate("/nfrac_awards");
            }}
            className="opts"
            id="nfrac_awards"
          >
            Awards
          </p>
          : <p
            onClick={() => {
              navigate("/nfrac_awards");
            }}
            className="opts hide"
          >
            Awards
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={() => {
              navigate("/nfrac_missions");
            }}
            className="opts"
            id="nfrac_missions"
          >
            Missions
          </p>
          : <p
            onClick={() => {
              navigate("/nfrac_missions");
            }}
            className="opts hide"
          >
            Missions
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={() => {
              if (
                document.getElementById("location_confirmation") != null &&
                document.getElementById("location_confirmation").style
                  .visibility == "hidden"
              )
                document.getElementById(
                  "location_confirmation"
                ).style.visibility =
                  "visible";
              else if (
                (document.getElementById("location_confirmation") != null &&
                  document.getElementById("location_confirmation").style
                    .visibility == "visible") ||
                document.getElementById("location_confirmation") != null
              )
                document.getElementById(
                  "location_confirmation"
                ).style.visibility =
                  "hidden";
              else {
                var location = document.createElement("center");
                location.id = "location_confirmation";
                var cancel = document.createElement("img");
                cancel.src = "x.png";
                cancel.id = "cancel";
                location.appendChild(cancel);
                var message = document.createElement("b");
                message.innerHTML = "Please confirm your location";
                location.appendChild(message);
                var bar = document.createElement("select");
                var s1 = document.createElement("option");
                s1.selected = true;
                var s2 = document.createElement("option");
                var s3 = document.createElement("option");
                s1.innerHTML = "India";
                s2.innerHTML = "USA";
                s3.innerHTML = "Egypt";
                bar.appendChild(s1);
                bar.appendChild(s2);
                bar.appendChild(s3);


                var div = document.createElement("div");
                var submit = document.createElement("button");

                div.appendChild(submit);

                submit.innerHTML = "Submit";


                location.appendChild(bar);
                location.appendChild(div);
                document.getElementById("root").appendChild(location);
                location.style.marginLeft =
                  window.screen.width > 750
                    ? `${window.screen.width / 2 -
                    location.clientWidth / 2}px`
                    : "10px";

                submit.addEventListener("click", () => {
                  if (bar.value === "India") {
                    window.open("https://itt-academy.web.app", "_self");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  } else if (bar.value === "USA") {
                    navigate("/nfrac_education_usa");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  }
                  else if (bar.value === "Egypt") {
                    navigate("/nfrac_education_egypt");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  }
                });

                cancel.addEventListener("click", () => {
                  document.getElementById(
                    "location_confirmation"
                  ).style.visibility =
                    "hidden";
                });
              }
            }}
            className="opts"
            id="nfrac_education"
          >
            ITTa-Edu
          </p>
          : <p
            onClick={() => {
              if (
                document.getElementById("location_confirmation") != null &&
                document.getElementById("location_confirmation").style
                  .visibility == "hidden"
              )
                document.getElementById(
                  "location_confirmation"
                ).style.visibility =
                  "visible";
              else if (
                (document.getElementById("location_confirmation") != null &&
                  document.getElementById("location_confirmation").style
                    .visibility == "visible") ||
                document.getElementById("location_confirmation") != null
              )
                document.getElementById(
                  "location_confirmation"
                ).style.visibility =
                  "hidden";
              else {
                var location = document.createElement("center");
                location.id = "location_confirmation";
                var cancel = document.createElement("img");
                cancel.src = "x.png";
                cancel.id = "cancel";
                location.appendChild(cancel);
                var message = document.createElement("b");
                message.innerHTML = "Please confirm your location";
                location.appendChild(message);
                var bar = document.createElement("select");
                var s1 = document.createElement("option");
                s1.selected = true;
                var s2 = document.createElement("option");
                var s3 = document.createElement("option");
                s1.innerHTML = "India";
                s2.innerHTML = "USA";
                s3.innerHTML = "Egypt";
                bar.appendChild(s1);
                bar.appendChild(s2);
                bar.appendChild(s3);

                var div = document.createElement("div");
                var submit = document.createElement("button");

                div.appendChild(submit);

                submit.innerHTML = "Submit";


                location.appendChild(bar);
                location.appendChild(div);
                document.getElementById("root").appendChild(location);
                location.style.marginLeft =
                  window.screen.width > 750
                    ? `${window.screen.width / 2 -
                    location.clientWidth / 2}px`
                    : "10px";

                submit.addEventListener("click", () => {
                  if (bar.value === "India") {
                    window.open("https://itt-academy.web.app", "_self");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  } else if (bar.value === "USA") {
                    navigate("/nfrac_education_usa");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  }
                  else if (bar.value === "Egypt") {
                    navigate("/nfrac_education_egypt");
                    document.getElementById(
                      "location_confirmation"
                    ).style.visibility =
                      "hidden";
                  }
                  document
                    .querySelector("#root > div > nav > div.bottom-nav > img")
                    .click();
                });

                cancel.addEventListener("click", () => {
                  document.getElementById(
                    "location_confirmation"
                  ).style.visibility =
                    "hidden";
                });
              }
            }}
            className="opts hide"
            id="nfrac_education"
          >
            ITTa-Edu
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={() => {
              navigate("/nfrac_research_papers");
            }}
            className="opts"
            id="nfrac_research_papers"
          >
            Research Papers
          </p>
          : <p
            onClick={() => {
              navigate("/nfrac_research_papers");
            }}
            className="opts hide"
          >
            Research Papers
          </p>}

        {window.screen.width > 750
          ? <p className="opts" id="department">
            <p
              onMouseEnter={() => {
                document
                  .querySelector("#abttm")
                  .classList.toggle("about_items_show");
                var arrow = document.querySelector("#arrow_direction_dept");
                arrow.innerHTML =
                  arrow.innerHTML == "keyboard_arrow_up"
                    ? "keyboard_arrow_down"
                    : "keyboard_arrow_up";
              }}
              className="detps"
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                Departments{" "}
                <span
                  id="arrow_direction_dept"
                  class="material-symbols-outlined"
                >
                  keyboard_arrow_down
                </span>
              </span>
            </p>

            <div id="abttm" className="about_items">
              <p
                onClick={() => {
                  localStorage.setItem("departmentName", "AIRD");
                  localStorage.setItem(
                    "departmentImage",
                    "departments/aiimage.jpg"
                  );
                  navigate("/department");
                }}
              >
                AIRD department
              </p>
              <p
                onClick={() => {
                  localStorage.setItem("departmentName", "CSRD");
                  localStorage.setItem(
                    "departmentImage",
                    "departments/csimage.jpg"
                  );
                  navigate("/department");
                }}
              >
                CSRD department
              </p>

              <p
                onClick={() => {
                  localStorage.setItem("departmentName", "VPLD");
                  localStorage.setItem(
                    "departmentImage",
                    "departments/vpld.png"
                  );
                  navigate("/department");
                }}
              >
                VPLD department
              </p>
              <p
                onClick={() => {
                  localStorage.setItem("departmentName", "GPLD");
                  localStorage.setItem(
                    "departmentImage",
                    "departments/gpld.png"
                  );
                  navigate("/department");
                }}
              >
                GPLD department
              </p>
              <p
                onClick={() => {
                  navigate("/viswakarman_technological_center");
                }}
              >
                Viśvakarmān Technological Center
              </p>
              <p
                onClick={() => {
                  window.open("https://itt-academy.web.app", "_self");
                }}
              >
                ITTacademy
              </p>
            </div>
          </p>
          : <p className="opts hide">
            <p
              onClick={() => {
                document
                  .querySelector(".options")
                  .classList.toggle("collapse");
              }}
              className="detps"
            >
              Departments
            </p>

            <div className="options collapse">
              <ul style={noTransition} className="list-of-depts">
                <li
                  style={noTransition}
                  onClick={e => {
                    localStorage.setItem("departmentName", "AIRD");
                    localStorage.setItem(
                      "departmentImage",
                      "departments/aiimage.jpg"
                    );
                    navigate("/department");
                  }}
                >
                  AIRD department
                </li>
                <li
                  style={noTransition}
                  onClick={e => {
                    localStorage.setItem("departmentName", "CSRD");
                    localStorage.setItem(
                      "departmentImage",
                      "departments/csimage.jpg"
                    );
                    navigate("/department");
                  }}
                >
                  CSRD department
                </li>

                <li
                  style={noTransition}
                  onClick={() => {
                    localStorage.setItem("departmentName", "VPLD");
                    localStorage.setItem(
                      "departmentImage",
                      "departments/vpld.png"
                    );
                    navigate("/department");
                  }}
                >
                  VPLD department
                </li>
                <li
                  style={noTransition}
                  onClick={() => {
                    localStorage.setItem("departmentName", "GPLD");
                    localStorage.setItem(
                      "departmentImage",
                      "departments/gpld.png"
                    );
                    navigate("/department");
                  }}
                >
                  GPLD department
                </li>
                <li
                  style={noTransition}
                  onClick={() => {

                    navigate("/viswakarman_technological_center");
                  }}
                >
                  Viśvakarmān Technological Center
                </li>
                <li
                  style={noTransition}
                  onClick={() => {
                    window.open("https://itt-academy.web.app", "_self");
                  }}
                >
                  ITTacademy
                </li>
              </ul>
            </div>
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={e => {
              e.preventDefault();
              navigate("/contact_nfrac");
            }}
            className="opts"
            id="contact_nfrac"
          >
            Contact Us
          </p>
          : <p
            onClick={e => {
              e.preventDefault();
              navigate("/contact_nfrac");
            }}
            className="opts hide"
          >
            Contact Us
          </p>}

        {window.screen.width > 750
          ? <p
            onClick={e => {
              e.preventDefault();
              // navigate("/join_nfrac");
              window.open("https://careers-nfrac.web.app", "_self");
            }}
            className="opts"
            id="join_nfrac"
          >
            Careers
          </p>
          : <p
            onClick={e => {
              e.preventDefault();
              // navigate("/join_nfrac");
              window.open("https://careers-nfrac.web.app", "_self");
            }}
            className="opts hide"
          >
            Careers
          </p>}
      </div>
    </nav>
  );
}

export default Navbar;
